/* eslint-disable */

import React from "react";

const RaindropClickable = ({
  onClick,
  isDisabled = false,
  children,
  additionalClasses = "",
}) => {
  let tailwindClass = "cursor-pointer md:hover:scale-[96%] active:scale-[94%]";

  if (isDisabled) {
    tailwindClass = "";
  }

  return (
    <div
      onClick={isDisabled ? null : onClick}
      className={`${tailwindClass} transition-all duration-100 ${additionalClasses} `}
    >
      {children}
    </div>
  );
};

export default RaindropClickable;
